import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { parseQueryParams } from "../../../libs/Util";
import { listActiveLearningPath } from "../../../studentStore";
import Button from "../../../atoms/ActiveLearning/Button";
import ActiveLearningModalConfirm from "../../../molecules/ActiveLearningModalConfirm";
import { ReactComponent as IconCheck } from "../../../assets/images/ActiveLearning/icon_check.svg";

import styles from "./EndLesson.module.scss";

interface IEndLessonProps {
  text?: string;
}

export const EndLesson: React.FC<IEndLessonProps> = ({ text }) => {
  const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
  const history = useHistory();
  const material_code = parseQueryParams()["code"];

  useEffect(() => {
    const blockOfHistoryPop = history.block((_location, action) => {
      if (action === "POP") {
        setIsShowModalConfirm(true);
        return false;
      }
    });

    return () => blockOfHistoryPop();
  }, [history]);

  return (
    <>
      <div className={styles.endLesson}>
        <div className={styles.wrapper}>
          <IconCheck className={styles.check} />
          <p className={styles.title}>
            本日のLessonは以上です。
            <br />
            お疲れさまでした！
          </p>
          <p className={styles.text}>{text}</p>
          <div className={styles.buttonWrapper}>
            <Button
              handleClick={() => {
                setIsShowModalConfirm(true);
              }}
            >
              一覧に戻る
            </Button>
          </div>
        </div>
      </div>
      {isShowModalConfirm && (
        <ActiveLearningModalConfirm
          onClose={() => setIsShowModalConfirm(false)}
          title={
            "回答を保存していない場合、今まで書いたデータが消えてしまいます。保存したかどうかを確認した上でページを移動しましょう。"
          }
          buttons={[
            {
              title: "ワークに戻る",
              action: () => {
                setIsShowModalConfirm(false);
              },
              type: "Success",
            },
            {
              title: "一覧へ移動する",
              action: () => {
                setIsShowModalConfirm(false);
                history.push(`${listActiveLearningPath}?code=${material_code}`);
              },
              type: "None",
            },
          ]}
        />
      )}
    </>
  );
};

export default EndLesson;
